export default "__VITE_ASSET__aMnjKFCv__"